import Vue from 'vue'

import AccountRepository from '@/repositories/AccountRepository'
import AccountRepositoryMock from '@/repositories/AccountRepositoryMock'
import AnnouncementRepository from '@/repositories/AnnouncementRepository'
import AnnouncementRepositoryMock from '@/repositories/AnnouncementRepositoryMock'
import CalendarRepository from '@/repositories/CalendarRepository'
import CalendarRepositoryMock from '@/repositories/CalendarRepositoryMock'
import CompanyRepository from '@/repositories/CompanyRepository'
import CompanyRepositoryMock from '@/repositories/CompanyRepositoryMock'
import ItemCategoryRepository from '@/repositories/ItemCategoryRepository'
import ItemCategoryRepositoryMock from '@/repositories/ItemCategoryRepositoryMock'
import ItemCategoryLevelRepository from '@/repositories/ItemCategoryLevelRepository'
import ItemCategoryLevelRepositoryMock from '@/repositories/ItemCategoryLevelRepositoryMock'
import ItemRepository from '@/repositories/ItemRepository'
import ItemRepositoryMock from '@/repositories/ItemRepositoryMock'
import MenuRepository from '@/repositories/MenuRepository'
import MenuRepositoryMock from '@/repositories/MenuRepositoryMock'
import PfvRepository from '@/repositories/PfvRepository'
import PfvRepositoryMock from '@/repositories/PfvRepositoryMock'
import RanksRepository from '@/repositories/RanksRepository'
import RanksRepositoryMock from '@/repositories/RanksRepositoryMock'
import SiteRepository from '@/repositories/SiteRepository'
import StoreRepository from '@/repositories/StoreRepository'
import StoreRepositoryMock from '@/repositories/StoreRepositoryMock'
import StoreGroupRepository from '@/repositories/StoreGroupRepository'
import StoreGroupRepositoryMock from '@/repositories/StoreGroupRepositoryMock'
import QueryLogRepository from '@/repositories/QueryLogRepository'
import QueryLogRepositoryMock from '@/repositories/QueryLogRepositoryMock'
import QueryReservationRepository from '@/repositories/QueryReservationRepository'
import QueryReservationRepositoryMock from '@/repositories/QueryReservationRepositoryMock'
import CustomerZipGroup from '@/repositories/CustomerZipGroupRepository'
import CustomerZipGroupMock from '@/repositories/CustomerZipGroupRepositoryMock'
import UploadFileRepository from '@/repositories/UploadFileRepository'
import OmatomeRepository from '@/repositories/OmatomeRepository'
import UserCustomerAttributeRepository from './UserCustomerAttributeRepository'
// Mouse
import DownloadRequestRepository from '@/repositories/DownloadRequestRepository'
// Link Legacy
import LinkLegacyRepository from '@/repositories/LinkLegacyRepository'
import TanawariRepository from '@/repositories/TanawariRepository'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.repositories) this.$repositories = options.repositories
    else if (options.parent && options.parent.$repositories)
      this.$repositories = options.parent.$repositories
  },
})

const masterRepositories = {
  account: AccountRepository,
  calendar: CalendarRepository,
  company: CompanyRepository,
  item: ItemRepository,
  itemCategory: ItemCategoryRepository,
  itemCategoryLevel: ItemCategoryLevelRepository,
  rank: RanksRepository,
  store: StoreRepository,
  storeGroup: StoreGroupRepository,
}

const giggleRepositories = {
  site: SiteRepository,
  announcement: AnnouncementRepository,
  menu: MenuRepository,
  pfv: PfvRepository,
  queryLog: QueryLogRepository,
  queryReservation: QueryReservationRepository,
  customerZipGroup: CustomerZipGroup,
  uploadFile: UploadFileRepository,
  linkLegacy: LinkLegacyRepository,
  omatome: OmatomeRepository,
  tanawari: TanawariRepository,
  userCustomerAttribute: UserCustomerAttributeRepository,
}

const mouseRepositories = {
  downloadRequest: DownloadRequestRepository,
}

const mockMasterRepositories = {
  account: AccountRepositoryMock,
  calendar: CalendarRepositoryMock,
  company: CompanyRepositoryMock,
  item: ItemRepositoryMock,
  itemCategory: ItemCategoryRepositoryMock,
  itemCategoryLevel: ItemCategoryLevelRepositoryMock,
  ranks: RanksRepositoryMock,
  store: StoreRepositoryMock,
  storeGroup: StoreGroupRepositoryMock,
}

const mockGiggleRepositories = {
  announcement: AnnouncementRepositoryMock,
  menu: MenuRepositoryMock,
  pfv: PfvRepositoryMock,
  queryLog: QueryLogRepositoryMock,
  queryReservation: QueryReservationRepositoryMock,
  customerZipGroup: CustomerZipGroupMock,
}

export default {
  get(name) {
    let repository

    if (process.env.VUE_APP_MASTER_API_URL_BASE) {
      repository = masterRepositories[name]
    } else {
      repository = mockMasterRepositories[name]
    }

    if (repository) {
      return repository
    }

    if (process.env.VUE_APP_QUERY_API_URL_BASE) {
      repository = giggleRepositories[name]
    } else {
      repository = mockGiggleRepositories[name]
    }

    if (repository) {
      return repository
    }

    if (process.env.VUE_APP_MOUSE_API_URL_BASE) {
      repository = mouseRepositories[name]
    } else {
      // repository = mockGiggleRepositories[name]
    }

    if (repository) {
      return repository
    }

    throw new Error(`リポジトリ ${name} が見つかりませんでした`)
  },
}
